<template>
  <div class="company_info">
    <el-form :model="cmpForm" label-width="120px">
      <div class="accountInfo_header_cla">
        {{ $t('tenant.integrationAccount') }}
      </div>
      <template v-for="item in companyDetailsInfo.integrationUser">
        <el-row :key="item.id">
          <el-form-item :label="$t('login.account')" style="width:50%">
            <el-input v-model="item.username" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item :label="$t('login.password')" style="width:50%">
            <el-input value="*******" type="password" :disabled="true">
              <template slot="append" v-if="hasPhoneAndEmail()">
                <el-button
                  type="primary"
                  @click="showUpdatePwd(item)"
                  icon="el-icon-edit"
                ></el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-row>
      </template>

      <el-divider></el-divider>

      <div class="companyContactInfo_cla">
        {{ this.$t('company.companyContactInfo') }}
      </div>

      <div class="contact-panel-cla flex-display-cla">
        <el-form-item
          class="form-item-cla flex-item-cla contact-cla formatted-name-cla"
          :label="this.$t('company.Contact')"
          prop="name"
          style="width:50%"
        >
          <el-input
            class="contact_input"
            :placeholder="this.$t('user.inputName')"
            v-model.trim="companyDetailsInfo.formattedName"
            :disabled="true"
          ></el-input>
        </el-form-item>

        <el-form-item
          class="form-item-cla flex-item-cla contact-cla"
          :label="this.$t('company.country')"
          prop="countryCode"
          style="width:50%"
        >
          <el-select
            @change="changeCountry"
            v-model.trim="companyDetailsInfo.countryCode"
            filterable
            placeholder
            style="width:100%"
            :disabled="true"
          >
            <el-option
              v-for="item in contryCode"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>

      <div class="contact-panel-cla">
        <div class="flex-display-cla">
          <el-form-item
            style="width: 50%;"
            class="form-item-cla flex-item-cla"
            :label="this.$t('company.phone')"
            prop="phone"
          >
            <el-input v-model="phone" :disabled="true">
              <template slot="prepend"
                >+{{ companyDetailsInfo.prefix }}</template
              >
            </el-input>
          </el-form-item>

          <el-form-item
            style="width:50%"
            class="form-item-cla flex-item-cla"
            :label="this.$t('company.email')"
            prop="email"
          >
            <el-input v-model.trim="email" :disabled="true"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('account.modifyPwd')"
      width="40%"
      @close="handleClose"
    >
      <el-form
        :model="interForm"
        label-width="140px"
        :rules="rules"
        ref="codeForm"
      >
        <template v-if="step === 'first'">
          <el-row :gutter="20">
            <el-col :span="16">
              <template v-if="isEmail">
                <el-form-item :label="this.$t('company.email')">
                  <el-input
                    v-model="interForm.email"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </template>
              <tempalte v-else>
                <el-form-item :label="this.$t('company.phone')">
                  <el-input
                    v-model="interForm.phone"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </tempalte>
            </el-col>
            <el-col :span="6" v-if="isChange">
              <el-button
                type="primary"
                @click="changeWay(isEmail)"
                :disabled="!isChange"
                >{{ $t('developer.changeWay') }}</el-button
              >
            </el-col>

            <el-col :span="16">
              <el-form-item :label="this.$t('center.code')" prop="code">
                <el-input v-model.trim="interForm.code" placeholder> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <timing
                ref="timing"
                @toGetCode="getEmailCode"
                :status="true"
                :isShow="true"
              >
              </timing>
            </el-col>
          </el-row>
        </template>
        <template v-if="step === 'second'">
          <el-form-item :label="$t('user.password')" prop="password">
            <el-input
              v-model.trim="interForm.password"
              autocomplete="off"
              type="password"
              :placeholder="this.$t('user.inputPwd')"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('user.confirmedPwd')" prop="secondPwd">
            <el-input
              v-model.trim="interForm.secondPwd"
              autocomplete="off"
              type="password"
              :placeholder="this.$t('user.input2ndPwd')"
            ></el-input>
          </el-form-item>
        </template>
        <template v-if="step === 'third'">
          <div
            style="width:100%;display:flex;flex-direction: column;justify-content:center;align-items:center;"
          >
            <i
              class="el-icon-circle-check"
              style="font-size:60px;display:block;color:#4db22f"
            ></i>
            <span>{{ $t('operationMsg.updateSuc') }}</span>
          </div>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="sumbitUpdate">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import timing from '@/components/timing'
import { getEmailCode, sendPhoneCode } from '@/services/userCenter.js'
import { verifyCode } from '@/services/acountApi.js'
import * as accountApi from '@/services/integratedAccountApi.js'

export default {
  components: {
    timing
  },
  props: {
    companyDetailsInfo: {
      type: Object
    },

    contryCode: {
      type: Object
    }
  },
  computed: {
    email() {
      return this.companyDetailsInfo.email
        ? this.emailFormat(this.companyDetailsInfo.email)
        : ''
    },
    phone() {
      return this.companyDetailsInfo.phone
        ? this.phoneFormat(this.companyDetailsInfo.phone)
        : ''
    }
  },
  watch: {
    email: {
      handler() {},
      immediate: true
    },
    phone: {
      handler() {},
      immediate: true
    }
  },
  data() {
    let checkCode = (rule, value, cb) => {
      if (value) {
        let params = {
          type: 'authentication',
          code: value
        }
        params.loginName = this.isEmail
          ? this.companyDetailsInfo.appEmail
          : this.companyDetailsInfo.appPhone
        verifyCode(params)
          .then(data => {
            if (data.code === '00000000') {
              return cb()
            } else {
              return cb(new Error(data.message))
            }
          })
          .catch(e => {})
      }
    }
    let checkRepasswd = (rule, value, callback) => {
      if (!(value + '')) {
        return callback(new Error(this.$t('user.input2ndPwd')))
      } else if (value !== this.interForm.password) {
        return callback(new Error(this.$t('user.pwdInconsistent')))
      } else {
        callback()
      }
    }
    return {
      cmpForm: {},
      interForm: {
        email: '',
        phone: '',
        code: '',
        password: '',
        secondPwd: ''
      },
      rules: {
        code: this.validatorInputEmptyRule(true, 6, checkCode),
        password: this.validatorPasswordRule(true),
        secondPwd: [
          { required: true, validator: checkRepasswd, trigger: 'blur' }
        ]
      },
      isEmail: false,
      isChange: false,
      dialogVisible: false,
      step: 'first',
      row: {}
    }
  },

  methods: {
    handleClose() {
      this.dialogVisible = false
      setTimeout(() => {
        this.interForm.code = ''
        if (this.$refs.codeForm) {
          this.$refs.codeForm.resetFields()
        }
        if (this.$refs.timing) {
          this.$refs.timing.clearTimer()
        }
      }, 300)
    },
    hasPhoneAndEmail() {
      let r = [undefined, '']
      if (
        r.includes(this.companyDetailsInfo.appPhone) &&
        r.includes(this.companyDetailsInfo.appEmail)
      ) {
        this.$message.warning(this.$t('warningOperation.hasPhoneOrEmail'))
        return false
      }
      return true
    },
    showUpdatePwd(info) {
      this.row = info
      if (this.hasPhoneAndEmail()) {
        this.step = 'first'
        this.dialogVisible = true
        this.interForm.phone =
          this.phoneFormat(this.companyDetailsInfo.appPhone) || ''
        this.interForm.email =
          this.emailFormat(this.companyDetailsInfo.appEmail) || ''
        if (
          this.companyDetailsInfo.appPhone &&
          this.companyDetailsInfo.appEmail
        ) {
          this.isChange = true
          this.isEmail = false
          return false
        }
        if (
          this.companyDetailsInfo.appPhone &&
          this.isEmptyData(this.companyDetailsInfo.appEmail)
        ) {
          this.isChange = false
          this.isEmail = false
          return false
        }

        if (
          this.isEmptyData(this.companyDetailsInfo.appPhone) &&
          this.companyDetailsInfo.appEmail
        ) {
          this.isChange = false
          this.isEmail = true
          return false
        }
      }
    },
    changeWay(val) {
      this.isEmail = !val
      this.$refs.timing.clearTimer()
    },
    sendCodeByType() {
      let params = { type: 'authentication' }
      this.isEmail
        ? (params.email = this.companyDetailsInfo.appEmail)
        : (params.phone = this.companyDetailsInfo.appPhone)
      const type = [getEmailCode, sendPhoneCode] // 获取验证的方式
      let result = {}
      type.forEach(item => {
        result[item] = () =>
          item(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$refs.timing.beginTime()
              } else {
                this.errorMessage(data.message)
              }
            })
            .catch(e => console.log(e))
      })
      return result
    },

    getEmailCode() {
      let send = this.isEmail
        ? this.sendCodeByType()[getEmailCode]
        : this.sendCodeByType()[sendPhoneCode]
      send.call(this)
    },
    sumbitUpdate() {
      if (this.step === 'first') {
        this.$refs.codeForm.validate(valid => {
          if (valid) {
            this.step = 'second'
          }
        })
      } else if (this.step === 'second') {
        this.$refs.codeForm.validate(valid => {
          if (valid) {
            let params = {
              companyId: this.companyDetailsInfo.companyId,
              id: this.row.id,
              username: this.row.username,
              password: this.interForm.password,
              code: this.interForm.code,
              loginName: this.isEmail
                ? this.companyDetailsInfo.appEmail
                : this.companyDetailsInfo.appPhone
            }
            accountApi
              .updateUsers(params)
              .then(data => {
                if (data.code === '00000000') {
                  this.step = 'third'
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => {})
          }
        })
      } else if (this.step === 'third') {
        this.dialogVisible = false
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';

.flex-display-cla {
  display: flex;
}
.com_header_cla {
  height: 22px;
  line-height: 22px;
  color: @fontColor1;
  font-weight: 600;
  padding-left: 16px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  letter-spacing: 0;
  position: relative;

  &::after {
    position: absolute;
    top: 3px;
    left: 0px;
    content: '';
    height: 16px;
    width: 4px;
  }
}

.company_info {
  .accountInfo_header_cla {
    .com_header_cla;
    margin-bottom: 20px;
    &::after {
      background: @themeColor;
    }
  }
}
.companyContactInfo_cla {
  margin: 20px 0px;
  .com_header_cla;
  &::after {
    background: @ststusFailed;
  }
}
.header-button-bar {
  margin: 20px 0;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/tenantManager/companyInfo/detailPage/companyInfomation.vue